var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettingDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.98,
    height: 20,
    viewBox: "0 0 19.98 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a5ff7c",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79ffd4",
    fill: "#000000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-solid",
    transform: "translate(-3.96 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_235",
    "data-name": "Path 235",
    d: "M23.693,12.48l-2.233-.667a7.767,7.767,0,0,0-.633-1.553L21.92,8.213a.407.407,0,0,0-.073-.48l-1.593-1.6a.407.407,0,0,0-.48-.073L17.74,7.147a7.747,7.747,0,0,0-1.573-.667L15.5,4.273A.407.407,0,0,0,15.107,4H12.853a.407.407,0,0,0-.387.287l-.667,2.2a7.753,7.753,0,0,0-1.587.667l-2-1.08a.407.407,0,0,0-.48.073l-1.62,1.58a.407.407,0,0,0-.073.48l1.08,2a7.753,7.753,0,0,0-.667,1.58l-2.207.667a.407.407,0,0,0-.287.387v2.253a.407.407,0,0,0,.287.387l2.22.667A7.747,7.747,0,0,0,7.133,17.7L6.04,19.793a.407.407,0,0,0,.073.48l1.593,1.593a.407.407,0,0,0,.48.073l2.06-1.1a7.767,7.767,0,0,0,1.533.627l.667,2.247a.407.407,0,0,0,.387.287h2.253a.407.407,0,0,0,.387-.287l.667-2.253a7.753,7.753,0,0,0,1.52-.627l2.073,1.107a.407.407,0,0,0,.48-.073l1.593-1.593a.407.407,0,0,0,.073-.48l-1.107-2.067a7.753,7.753,0,0,0,.633-1.527l2.247-.667a.407.407,0,0,0,.287-.387V12.873a.407.407,0,0,0-.247-.393ZM13.98,17.667A3.667,3.667,0,1,1,17.647,14a3.667,3.667,0,0,1-3.667,3.667Z",
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingDark);
export default __webpack_public_path__ + "static/media/setting-dark.edfea5559a515a79d61699a53005ddf3.svg";
export { ForwardRef as ReactComponent };